import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {ErrorBoundary} from '@components/common/error-boundary/error-boundary'
import {UserProxy} from '@extensions/proxies/user-proxy'
import React from 'react'
import {DataObjectId, ObjectType, UserEvent} from 'yougile-model'
import {logger} from 'yougile-util'
import {StatisticsRow} from './row'

interface Props {
  user: UserProxy
  event: UserEvent
  timestamp: number
  errors: Set<number>
  restore: (objId: DataObjectId, objType: ObjectType) => void
  reportError: (timestamp: number) => void
}

export const StatisticsRows = (props: Props) => {
  const {user, event, timestamp, restore, errors, reportError} = props

  const onError = () => {
    logger.warn('Error with event item', event)
    reportError(timestamp)
  }
  const box = Sync.getCurrentSandbox()
  const hierarchy = DepartmentsClient.getHierarchy(box)
  return (
    <ErrorBoundary key={timestamp} silent={true} onError={onError}>
      <StatisticsRow
        user={user}
        event={event}
        time={timestamp}
        restore={restore}
        hasError={errors.has(timestamp)}
        hierarchy={hierarchy}
      />
    </ErrorBoundary>
  )
}
